import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { getEmail, getRole } from "../../../DecodeToken/DecodeToken";
import {
  getAccountData,
  sendEmailOtp,
  updatePassword,
  updatePhoneNumber,
} from "../../../ApiServices/ApiServices";
import { handleError, handleSuccess } from "../../../Utils";
import ComingSoon from "../../../Pages/ComingSoon/ComingSoon";
import AccountDeletion from "./AccountDeletion";

const Account = () => {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("******");
  const [notificationPreference, setNotificationPreference] = useState("email");

  const [editingPhone, setEditingPhone] = useState(false);
  const [editingPassword, setEditingPassword] = useState(false);
  const [newPhone, setNewPhone] = useState(phone.split(" ")[1]);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showAccountDeletionModel, setShowAccountDeletionModel] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const [phoneError, setPhoneError] = useState(""); // For phone validation error
  const [passwordError, setPasswordError] = useState(""); // For password validation error
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");
  const email = getEmail();
  const role = getRole();
  const [isComingSoonVisible, setIsComingSoonVisible] = useState(false);

  useEffect(() => {
    document.title = "Dashboard - Account";
    setNewPhone(phone.split(" ")[1] || "");
    const accountData = async () => {
      try {
        const accountData = await getAccountData(email, role);
        setPhone(accountData.data.phone);
      } catch (error) {
        handleError(error?.response.data.message);
      } finally {
        setLoading(false);
      }
    };
    if (token) {
      accountData();
    }
  }, [email, token]);

  const handleNotificationChange = (event) => {
    setNotificationPreference(event.target.value);
  };

  const handlePhoneEdit = () => {
    setEditingPhone(true);
  };

  const handlePhoneSave = async () => {
    try {
      if (/^\d{10}$/.test(newPhone)) {
        const response = await updatePhoneNumber(email, newPhone, role);
        handleSuccess(response.message);
        setEditingPhone(false);
      } else {
        setPhoneError("Phone number should be of 10 digits.");
        setTimeout(() => {
          setPhoneError("");
        }, [2000]);
      }
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  const handlePhoneCancel = () => {
    setNewPhone(phone.split(" ")[1]);
    setPhoneError(""); // Clear error on cancel
    setEditingPhone(false);
  };

  const handlePasswordEdit = () => {
    setEditingPassword(true);
  };
  const handlePasswordSave = async () => {
    try {
      if (newPassword === confirmPassword) {
        if (newPassword.length >= 6 && newPassword.length <= 12) {
          const response = await updatePassword(email, newPassword, role);
          handleSuccess(response.message);
          setNewPassword("");
          setConfirmPassword("");
          setEditingPassword(false);
        } else {
          setPasswordError("Password must be between 6 and 12 characters.");
          setTimeout(() => {
            setPasswordError(""); // Clear error message after 2 seconds
          }, 2000);
        }
      } else {
        setPasswordError("Passwords do not match!");
        setTimeout(() => {
          setPasswordError(""); // Clear error message after 2 seconds
        }, 2000);
      }
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  const handlePasswordCancel = () => {
    setNewPassword("");
    setConfirmPassword("");
    setPasswordError(""); // Clear error on cancel
    setEditingPassword(false);
  };

  const handleDeleteAccount = () => {
    // setIsComingSoonVisible(true);
    setShowDeleteConfirmation(true);
  };

  const confirmDelete = async() => {
    setShowDeleteConfirmation(false);
    setShowAccountDeletionModel(!showAccountDeletionModel);
    try {
      const res = await sendEmailOtp(email);
      handleSuccess(res?.message);
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  const cancelDelete = () => {
    setShowDeleteConfirmation(false);
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  if (loading) return <p>Loading profile...</p>;

  return (
    <div className="flex-col items-center">
      <div className="w-72 md:w-96">
        {/* "Your Details" Heading */}
        <h1 className="mb-8 text-3xl font-semibold text-center">
          Your Details
        </h1>
        {/* Account Details Section */}
        <div className="mb-3">
          <div className="mb-4">
            <div className="flex flex-col">
              <label className="text-black font-bold mb-2">Email Address</label>
              <input
                type="email"
                value={email}
                readOnly
                className="max-w-[500px] text-gray-900 w-full sm:w-auto"
              />
            </div>
          </div>
          <hr className="mt-2 mb-3"></hr>
          <div className="mb-2">
            <label className="text-black font-bold mb-2">Phone Number:</label>
            {editingPhone ? (
              <>
                <div className="flex gap-1 items-center">
                  {/* Country Code (Non-editable) */}
                  <input
                    type="text"
                    value={"+91"}
                    readOnly
                    className="p-2 border border-gray-300 rounded w-16 sm:w-24"
                  />
                  {/* Editable Phone Number */}
                  <input
                    type="text"
                    value={newPhone}
                    onChange={(e) => setNewPhone(e.target.value)}
                    placeholder="Enter new phone number"
                    className="p-2 border border-gray-300 rounded w-auto sm:w-36"
                  />
                </div>
                {phoneError && (
                  <div className="text-red-500 text-sm mt-1">{phoneError}</div>
                )}
                <div className="flex gap-1 mt-2 sm:flex-wrap">
                  <div
                    className="primary-btn w-auto sm:w-auto text-center py-2 bg-blue-500 text-white rounded cursor-pointer"
                    onClick={handlePhoneSave}
                  >
                    Save
                  </div>
                  <div
                    className="secondary-btn w-auto sm:w-auto text-center py-2 bg-gray-300 text-gray-700 rounded cursor-pointer"
                    onClick={handlePhoneCancel}
                  >
                    Cancel
                  </div>
                </div>
              </>
            ) : (
              <div className="relative">
                <input
                  type="text"
                  value={phone}
                  readOnly
                  className="w-auto mb-2"
                />
                <span
                  className="absolute left-48 top-1/2 transform -translate-y-1/2 cursor-pointer text-black-600 px-3"
                  onClick={handlePhoneEdit}
                >
                  Edit
                </span>
              </div>
            )}
          </div>
          <hr className="mt-2 mb-2"></hr>
          <div className="mb-2">
            <label className="text-black font-bold mb-2">Password:</label>
            {editingPassword ? (
              <>
                <div className="relative mb-2">
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Enter new password"
                    className="w-full p-2 border border-gray-300 rounded pr-12" // Ensure padding on right to fit the eye icon
                  />
                  <span
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={togglePasswordVisibility}
                  >
                    {isPasswordVisible ? (
                      <AiFillEyeInvisible size={20} />
                    ) : (
                      <AiFillEye size={20} />
                    )}
                  </span>
                </div>
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  className="w-full p-2 border border-gray-300 rounded"
                />
                {passwordError && (
                  <div className="text-red-500 text-sm mt-1">
                    {passwordError}
                  </div>
                )}
                <div className="flex gap-1 mt-2 sm:flex-wrap">
                  <div
                    className="primary-btn w-full sm:w-auto text-center py-2 bg-blue-500 text-white rounded cursor-pointer"
                    onClick={handlePasswordSave}
                  >
                    Save
                  </div>
                  <div
                    className="secondary-btn w-full sm:w-auto text-center py-2 bg-gray-300 text-gray-700 rounded cursor-pointer"
                    onClick={handlePasswordCancel}
                  >
                    Cancel
                  </div>
                </div>
              </>
            ) : (
              <div className="relative">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  value={password}
                  readOnly
                  className="w-auto"
                />
                <span
                  className="absolute left-48 top-1/2 transform -translate-y-1/2 cursor-pointer text-black-600 px-3"
                  onClick={handlePasswordEdit}
                >
                  Edit
                </span>
              </div>
            )}
          </div>
        </div>
        <hr className="mt-2 "></hr>
        {/* Notification Section */}
        <div className="bg-white ">
          <h3 className="text-2xl font-semibold py-3 mb-2 text-center">
            Notifications
          </h3>
          <div className="flex items-center gap-3 flex-wrap">
            <label className="text-left">Booking Notifications:</label>
            <select
              value={notificationPreference}
              onChange={handleNotificationChange}
              className="p-2 border border-gray-300 rounded w-28 sm:w-36"
            >
              <option value="email">Email</option>
              <option value="whatsapp">WhatsApp</option>
              <option value="both">Both</option>
            </select>
            <div className="primary-btn w-96" onClick={setIsComingSoonVisible}>
              Save Changes
            </div>
          </div>
        </div>
      </div>
      <hr className="mt-3 mb-4"></hr>
      <div className="flex items-center justify-between flex-wrap space-x-4">
        {/* Help Text and Link */}
        <div className="text-left mt-2">
          <p>
            Do you need help with your account settings?{" "}
            <Link to="/contact" className="text-blue-600">
              Send your query
            </Link>
          </p>
        </div>

        {/* Delete Account Section */}
        <div className="my-3 ">
          <button
            className="delete-btn"
            style={{ width: "200px", height: "50px" }}
            onClick={handleDeleteAccount}
          >
            Delete Account
          </button>
        </div>
      </div>
      {/* Delete Account Confirmation Dialog */}
      {showDeleteConfirmation && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-10">
          <div className="bg-white p-3 py-4 border rounded-lg shadow-lg text-center">
            <p className="mb-4">
              Are you sure you want to delete your account?
            </p>
            <div className="flex justify-center gap-6 sm:flex-wrap">
              <div className="delete-btn" onClick={confirmDelete}>
                YES
              </div>
              <div className="secondary-btn px-6" onClick={cancelDelete}>
                NO
              </div>
            </div>
          </div>
        </div>
      )}
      <ComingSoon
        isVisible={isComingSoonVisible}
        setIsVisible={setIsComingSoonVisible}
      />
      {showAccountDeletionModel && (<AccountDeletion setIsVisible={setShowAccountDeletionModel} />)}
    </div>
  );
};

export default Account;
